module.exports = __webpack_public_path__ + "fonts/Outfit-Black.d032ccd6.ttf";